module.exports = __webpack_public_path__ + "assets/img/00055.e2a9cd9c.png";